import styled from "styled-components";
import { ClientSettingsDropdownListItemDefaultBox } from "./dropdown-list-item.default.box";

export const ClientSettingsDropdownSelectedCasino777Box = styled(ClientSettingsDropdownListItemDefaultBox)`
    color: ${({ isSelected, theme }) => isSelected ? theme.colors.brandPrimary : theme.colors.text};

    &:hover {
        color: ${({ isSelected, theme }) => isSelected ? theme.colors.brandPrimary : theme.colors.textContrast};
    }
`